import * as React from "react";
const SvgFiRrShower = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shower_svg__a)">
      <path
        fill="#062147"
        d="M19 12.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 19 12.5M22.5 9a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 22.5 9m-5 7a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 17.5 16m5-5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 22.5 11m0 5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 22.5 16m0 5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 22.5 21m-5 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 17.5 21m-5-5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12.5 16m0 5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12.5 21m7.415-18.396a3.05 3.05 0 0 1-.812 2.883l-7.617 7.617a3.04 3.04 0 0 1-2.882.811 3 3 0 0 1-2.172-1.994 7.6 7.6 0 0 1-.352-1.787c-.239-3.224.046-5.635.833-7.216a5.3 5.3 0 0 0-2.997-.917 1.92 1.92 0 0 0-1.917 1.917v19.083a1 1 0 1 1-2 0V3.917A3.923 3.923 0 0 1 3.917 0a7.3 7.3 0 0 1 4.261 1.367C9.691.237 12.356-.202 16.133.08a7.5 7.5 0 0 1 1.788.353 3 3 0 0 1 1.994 2.171m-1.945.465a1 1 0 0 0-.67-.735 5.6 5.6 0 0 0-1.313-.259Q14.966 2 14.062 2c-2.419 0-4.167.4-4.915 1.147-.934.934-1.324 3.427-1.072 6.84.033.445.121.889.259 1.314.158.482.567.629.735.669.367.09.741-.018 1.003-.28l7.617-7.617a1.06 1.06 0 0 0 .281-1.004"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shower_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShower;
